export default {
  saturationCurves: 'Saturation Curves',
  generalView: 'General View',
  optimalZones: 'Optimal Zones',
  noOptimalZonesData: '{name} doesn\'t include Optimal Zones data.',
  marginalRoas: 'Marginal ROAS',
  showHistoricalSpend: 'Historical spend datapoints',
  showSpend: 'Spend datapoints',
  exportCurves: 'Export curves',
  // Control names, used by the Admin tab's hidden-sections list
  groupSelector: 'Group selector',
  periodCollapseSelector: 'Spend datapoints selector',
  spendUnit: 'Spend Unit',
  spend: 'Spend',
  monthly: 'Monthly',
  weekly: 'Weekly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
  monthlyAvg: 'Monthly Average',
  quarterlyAvg: 'Quarterly Average',
  yearlyAvg: 'Yearly Average',
  none: 'None',
  ok: 'Ok',
  cancel: 'Cancel',
  save: 'Save',
  aboutOptimalZones: 'About Optimal Zones',
  zone1: 'Zone 1',
  zone1Desc: 'This range should generally be avoided, as it falls below a Minimum Spending Threshold, resulting in negligible contributions. Any dollars spent in this zone are essentially wasted.',
  zone2: 'Zone 2',
  zone2Desc: 'In this range, dollars spent begin to show a small but rapidly growing marginal contribution. Typically, small increases in spending yield high gains in marginal contribution, until the point where Maximum Marginal Contribution is reached.',
  zone3: 'Zone 3',
  zone3Desc: 'This range, along with the next, is generally considered "optimal". As spending increases in this range, the marginal contribution of each additional dollar spent gradually diminishes, although the Return On Ad Spend (ROAS) for each dollar continues to grow.',
  zone4: 'Zone 4',
  zone4Desc: 'This range, along with the previous one, is generally considered "optimal". However, unlike in Zone 3, as spending increases in this range, ROAS gradually decreases, making further spending increasingly less efficient.',
  zone5: 'Zone 5',
  zone5Desc: 'Similar to Zone 1, this range generally should be avoided, as it represents spending beyond what is efficient. In this zone, the contribution of each additional dollar is so small that it\'s essentially a waste of resources.',
  aboutMarginalRoas: 'About Marginal ROAS',
  marginalRoasDesc: 'The Marginal ROAS (mROAS) is the incremental return generated by each additional unit of investment — that is, the slope (derivative) of the saturation curve. Each chart overlays the saturation curve (left axis) with its marginal curve (right axis): the marginal value at a given spend level is the difference in incremental contribution divided by the difference in spend between that level and the previous one.',
  averageCpi: 'Average CPI',
  enterCpiInstructions: 'Enter average Cost Per Impression (MXN) for each media channel:',
  editAverageCpi: 'Edit Average Cost Per Impression'
}
